import { render, staticRenderFns } from "./DialogShare.vue?vue&type=template&id=6770c87d&scoped=true"
import script from "./DialogShare.vue?vue&type=script&lang=js"
export * from "./DialogShare.vue?vue&type=script&lang=js"
import style0 from "./DialogShare.vue?vue&type=style&index=0&id=6770c87d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6770c87d",
  null
  
)

export default component.exports